import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Industries from "@/pages/Industries";
import Solutions from "@/pages/Solutions";
import Technologies from "@/pages/Technologies";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import TrainingAcademy from "@/pages/TrainingAcademy";
import TrainingDetail from "@/pages/TrainingDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import "@/App.css";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/technologies" element={<Technologies />} />
          <Route path="/training" element={<TrainingAcademy />} />
          <Route path="/training/:slug" element={<TrainingDetail />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<InsightDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
